module.exports = __webpack_public_path__ + "img/timeline_mainevent-9.e7ee1b14.jpg";